/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Markdown from '../markdown-render';
import { Container, Header, FeaturedLink } from './featured-navigation-css';
import { ButtonContainer, ButtonText } from '../button/button';

const FeaturedNavigation = ({ intro, featuredLinks }) => (
  <Container>
    <Header>
      <Markdown source={intro} />
    </Header>
    <ButtonContainer>
      {featuredLinks.map(({ title, slug }) => (
        <FeaturedLink key={slug} to={`/${slug}`}>
          <ButtonText>{title}</ButtonText>
        </FeaturedLink>
      ))}
      {/* Manually added a mailto button for now. -LR */}
      <FeaturedLink key="mailto:brand@cmegroup.com" to="mailto:brand@cmegroup.com">
        <ButtonText>Contact the Brand Team</ButtonText>
      </FeaturedLink>

    </ButtonContainer>
  </Container>
);

FeaturedNavigation.propTypes = {
  intro: PropTypes.string.isRequired,
  featuredLinks: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })),
};

FeaturedNavigation.defaultProps = {
  featuredLinks: null,
};

const FeaturedNavigationWithQuery = (props) => {
  const { contentfulFeaturedNavigation } = useStaticQuery(graphql`
    query{
      contentfulFeaturedNavigation(title: {eq: "Need something else?"}) {
        intro {
          intro
        }
        featuredNavigation {
          links {
            title
            slug
          }
        }
      }
    }
  `);

  const [...intro] = contentfulFeaturedNavigation.intro.intro;
  const [...links] = contentfulFeaturedNavigation.featuredNavigation.links;
  return (
    <FeaturedNavigation
      intro={intro}
      featuredLinks={links}
      {...props}
    />
  );
};

export default FeaturedNavigationWithQuery;
